const TipSection = ({ title, children, isAlt }) => {
  return (
    <section className={`py-16 px-8 ${isAlt ? '' : 'bg-white'}`} style={{ backgroundColor: isAlt ? '#f2f4f7' : '#fff' }}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-light mb-8" style={{ color: '#2b3d57' }}>
          {title}
        </h2>
        <div className="text-base leading-relaxed" style={{ color: '#2b3d57' }}>
          {children}
        </div>
      </div>
    </section>
  );
};

export default TipSection;
